<template>
  <!-- Pricing Cards Skeleton -->
  <div v-if="type === SKELETON_LOADER_TYPES.PRICING_CARDS" class="flex flex-row gap-2 flex-wrap justify-center proxima_nova w-full">
    <div v-for="index in 3" :key="index" class="pricing-card-skeleton">
      <div class="h-[14px] w-[60px] bg_dark_6 hsk pulse mr-4" />
      <div class="h-[18px] w-[50px] bg_dark_6 hsk pulse mr-1" />
      <div class="h-[13px] w-[80px] bg_dark_6 hsk pulse" />
    </div>
  </div>

  <!-- Pricing Table Skeleton -->
  <div v-else-if="type === SKELETON_LOADER_TYPES.PRICING_TABLE" class="flex flex-col w-full">
    <div class="flex flex-col gap-[18px]">
      <div class="overflow-x-scroll">
        <div class="custom_table">
          <div class="table_container">
            <!-- Table Header Skeleton -->
            <div class="flex w-full">
              <div class="grid table_head" style="display: grid; grid-template-columns: repeat(12, minmax(0, 1fr)); width: 100%">
                <div class="col-span-6 table_header">
                  <div class="h-[14px] w-[150px] bg_dark_6 hsk pulse" />
                </div>
                <div class="col-span-6 table_header">
                  <div class="h-[14px] w-[180px] bg_dark_6 hsk pulse" />
                </div>
              </div>
            </div>
            <!-- Table Rows Skeleton -->
            <div class="flex flex-col">
              <div v-for="rowIndex in 3" :key="rowIndex" class="flex w-full">
                <div class="grid table_row" style="display: grid; grid-template-columns: repeat(12, minmax(0, 1fr)); width: 100%">
                  <div class="col-span-6 table_data">
                    <div class="h-[16px] w-[100px] bg_dark_6 hsk pulse" />
                  </div>
                  <div class="col-span-6 table_data">
                    <div class="h-[16px] w-[80px] bg_dark_6 hsk pulse" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { SKELETON_LOADER_TYPES } from '@/constants/skeletonLoaderConstants';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => Object.values(SKELETON_LOADER_TYPES).includes(value),
  },
});
</script>

<style scoped>
.pricing-card-skeleton {
  display: flex;
  flex-direction: row;
  padding: 12px;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  background: var(--white-opacity-6);
  flex: 1;
  white-space: nowrap;
}

.bg_dark_6 {
  background-color: var(--white-opacity-6);
}

.hsk {
  border-radius: 4px;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Match CustomTable styles */
:deep(.custom_table) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: var(--foreground-rgb);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: min-content;
  overflow: hidden;
}

:deep(.table_container) {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  overflow-y: hidden;
  border: 1px solid var(--white-opacity-20);
  border-radius: 8px;
}

:deep(.table_head),
:deep(.table_row) {
  display: grid;
  align-items: stretch;
}

:deep(.table_head) {
  background-color: var(--white-opacity-8);
}

:deep(.table_header) {
  display: flex;
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  overflow: hidden;
  color: var(--secondary-color);
  font-family: 'Proxima Nova', sans-serif;
  font-size: 14px;
  font-weight: 600;
}

:deep(.table_data) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 8px;
  align-self: stretch;
  overflow: hidden;
  color: var(--foreground-rgb);
  font-family: 'Proxima Nova', sans-serif;
  font-size: 14px;
  font-weight: 400;
}

:deep(.table_row) {
  border-bottom: 1px solid var(--white-opacity-20);
}
</style>
